export default __webpack_public_path__ + "static/media/satoshicity.d59eb4d2.png";